import React, { useCallback, useEffect } from 'react';
import { batch, useDispatch } from 'react-redux';
import { Icon } from '@vectord/components';

import {
  COURSE_PAUSE_REQUEST_APPROVE_MODAL_STAGES,
  setCoursePauseRequestApproveModalStage,
  setSelectedRequest,
} from 'features/courseResume';
import styles from './CoursePauseRequestApproveModalSuccessStage.module.scss';

function CoursePauseRequestApproveModalSuccessStage() {
  const dispatch = useDispatch();

  const handleModalClose = useCallback(() => {
    batch(() => {
      dispatch(setSelectedRequest(null));
      dispatch(
        setCoursePauseRequestApproveModalStage(
          COURSE_PAUSE_REQUEST_APPROVE_MODAL_STAGES.notOpen
        )
      );
    });
  }, [dispatch]);

  useEffect(() => {
    const timer = setTimeout(() => {
      handleModalClose();
    }, 1000);

    return () => {
      clearTimeout(timer);
    };
  }, [dispatch, handleModalClose]);

  return (
    <div className={styles.root}>
      <Icon
        name="tick-circle"
        className="h3 success bold m-b-xs"
      />
      <div className={styles.approved}>Request Approved Successfully</div>
    </div>
  );
}

export default CoursePauseRequestApproveModalSuccessStage;
